export class Rating {
  name: string;
  id: number;
  expirationDate: Date;
}
